let countrySettingItems = [
  {
    countryCode: 'pl',
    flagCode: 'pl',
    name: 'Poland',
    culture: 'pl-PL',
    coordinates: '&ll=51.573657,19.597711',
    googleMapZoom: '6',
    countryDBcode: '20',
    subCommunities:[]
  },
  {
    countryCode: 'dk',
    flagCode: 'dk',
    name: 'Denmark',
    culture: 'da-DK',
    coordinates: '&ll=55.676098,12.568337',
    googleMapZoom: '7',
    countryDBcode: '40',
    subCommunities:[]
  },
  {
    countryCode: 'no',
    flagCode: 'no',
    name: 'Norway',
    culture: 'nb-NO',
    coordinates: '&ll=59.911491,10.757933',
    googleMapZoom: '6',
    countryDBcode: '60',
    subCommunities:[]
  },
  {
    countryCode: 'fi',
    flagCode: 'fi',
    name: 'Finland',
    culture: 'fi-FI',
    coordinates: '&ll=60.192059,24.945831',
    googleMapZoom: '5',
    countryDBcode: '70',
    subCommunities:[]
  },
  {
    countryCode: 'it',
    flagCode: 'it',
    name: 'Italy',
    culture: 'it-IT',
    coordinates: '&ll=41.902782,12.496366',
    googleMapZoom: '6',
    countryDBcode: '80',
    subCommunities:[]
  },
  {
    countryCode: 'cz',
    flagCode: 'cz',
    name: 'Czechia',
    culture: 'cs-CZ',
    coordinates: '&ll=49.812259,15.456887',
    googleMapZoom: '7',
    countryDBcode: '22',
    subCommunities:[]
  }
]

const ALLOWED_COUNTRIES_CODES = 'allowedCountriesCodes'
const SELECTED_COUNTRY_CODE = 'selectedCountryCode'
const SUBCOMMUNITIES = 'subcommunities'
const SELECTED_SUBCOMMUNITY = 'selectedSubcommunity'

// ----------------------------------

export function setAllowedCountries(allowedCountriesCodes) {
  localStorage.setItem(ALLOWED_COUNTRIES_CODES, allowedCountriesCodes);
}

export function setSelectedCountry(selectedCountryCode) {
  localStorage.setItem(SELECTED_COUNTRY_CODE, selectedCountryCode);
}

export function setSubcommunities(subcommunities) {
  localStorage.setItem(SUBCOMMUNITIES, subcommunities);
}

export function setSelectedSubcommunity(selectedSubcommunity) {
  localStorage.setItem(SELECTED_SUBCOMMUNITY, selectedSubcommunity);
}

export function clearCountrySettings() {
  localStorage.removeItem(ALLOWED_COUNTRIES_CODES);
}

// ----------------------------------

function getSelectedCountrySettings() {
  let countryCode = localStorage.getItem(SELECTED_COUNTRY_CODE);

  if (!countryCode) {
    return null;
  }

  return countrySettingItems.find((item) => {
    return item.countryCode.toLowerCase() === countryCode.toLowerCase()
  })
}

export function getAllowedCountriesSettings() {
  let allowedCountriesCodes = localStorage.getItem(ALLOWED_COUNTRIES_CODES);

  if (!allowedCountriesCodes) {
    return [];
  }

  allowedCountriesCodes = allowedCountriesCodes.split(',')

  return countrySettingItems.filter((item) => {
    return allowedCountriesCodes.indexOf(item.countryCode.toLocaleUpperCase()) > -1
  })
}

export function getSelectedCountryCode() {
  return localStorage.getItem(SELECTED_COUNTRY_CODE);
}

export function getSelectedFlagCode() {
  let countrySettings = getSelectedCountrySettings();

  return countrySettings ? countrySettings.flagCode : '';
}

export function getSelectedCulture() {
  let countrySettings = getSelectedCountrySettings();

  return countrySettings.culture;
}

export function getCurrencySeparator() {
  return (0.1).toLocaleString(getSelectedCulture()).charAt(1);
}

export function getCurrentCountryAndCoordinates(){
  let countryCode = localStorage.getItem(SELECTED_COUNTRY_CODE);
  return countrySettingItems.find((item) => item.countryCode==countryCode).name + countrySettingItems.find((item) => item.countryCode==countryCode).coordinates;
}

export function getZoomForGoogleMap(){
  let countryCode = localStorage.getItem(SELECTED_COUNTRY_CODE);
  return countrySettingItems.find((item) => item.countryCode==countryCode).googleMapZoom;
}

export function getCountryNames(){
return  countrySettingItems.filter(element => (element.name != 'Audiopia')).map(element => (
    {
      value: element.culture.substring(element.culture.indexOf('-') + 1),
      label: element.name,
      parameters: null,
    }
  ))
}

export function getCountryDBcode(){
  let countryCode = localStorage.getItem(SELECTED_COUNTRY_CODE);
  return countrySettingItems.find((item) => item.countryCode===countryCode.toLowerCase()).countryDBcode;
}

export function getSubCommunities(){
  if(localStorage.getItem(SUBCOMMUNITIES)){
    let subCommunities = localStorage.getItem(SUBCOMMUNITIES);
    return ''
  }
  return '';
}

export function getSelectedSubCommunity() {
  if(localStorage.getItem(SELECTED_SUBCOMMUNITY) && localStorage.getItem(SELECTED_SUBCOMMUNITY) !== 'undefined'){
    return localStorage.getItem(SELECTED_SUBCOMMUNITY);
  }else{
    return getSubCommunities()[0];
  }

}

export function getSubCommunityLabel(){
  if(getSelectedSubCommunity()){
    let countryWithSubCommunities =  countrySettingItems.find((item) => item.subCommunities.length!==0);
    if(countryWithSubCommunities){
      let subCommunities = countryWithSubCommunities.subCommunities;
      let subCommunityObj =  subCommunities.find((item) => item.name===getSelectedSubCommunity());
      return subCommunityObj.label;
    }
    return '';
  }
}

export function getSubCommunityNameByLabel(label){
  let subCommunities = getSubCommunitiesData();//tu to poprawy
  let countryObj = subCommunities.find((item) => item.label===label);
  return countryObj.name;
}

export function getMessagesLanguageCodeBySubCommunity(){
  let subCommunities = getSubCommunitiesData();//tu to poprawy
  if(subCommunities.length>1){
    let selectedSubCommunity = getSelectedSubCommunity()
    let countryObj = subCommunities.find((item) => item.name===selectedSubCommunity);
    return countryObj.messagesLanguageCode;
  }
  if(typeof subCommunities === 'object'){
    return subCommunities.messagesLanguageCode;
  }
}

export function getSubCommunitiesData(){
  if(localStorage.getItem(SUBCOMMUNITIES)){
    let subCommunities = localStorage.getItem(SUBCOMMUNITIES).split(',');
    if(subCommunities.length>1){
      let countryWithSubCommunities =  countrySettingItems.find((item) => item.subCommunities.length!==0);
      if(countryWithSubCommunities){
        if(countryWithSubCommunities.countryCode == localStorage.getItem(SELECTED_COUNTRY_CODE)){
          return countryWithSubCommunities.subCommunities;
        }
      }
      return '';

    }else{
      let countryWithSubCommunities =  countrySettingItems.find((item) => item.subCommunities.length!==0);
      let subCommunitiesFromCountry = countryWithSubCommunities.subCommunities;
      let subCommunityBySelectedSubCommunity =  subCommunitiesFromCountry.find((item) => item.name==getSelectedSubCommunity());
      if(countryWithSubCommunities.countryCode == localStorage.getItem(SELECTED_COUNTRY_CODE)){
        return subCommunityBySelectedSubCommunity;
      }
    }
  }
  return'';
}

export function getCurrentCountryCode(){
  return localStorage.getItem(SELECTED_COUNTRY_CODE);
}
